module.exports ={
    overview: {
        on:'Online',
        off:'Offline',
        unit:'',
        gateway:{
            title:'Gateway'
        },
        label:{
            title:'ESL'
        },
        labelUpdate:{
            title:'Update',
            success: 'Succeeded',
            fail: 'Failed'
        },
        labelBattery:{
            title:'Battery Level',
            normal:'Normal',
            exception:'Low'
        },
        operate:{
            title:'Operation',
            updateData:'Label updates overview',
            unitUpdateSuccess:'Succeeded/ times',
            unitUpdate:'Updated/ times',
            updateSuccessRate:'Succeeded Rate',
            updateSuccess:'Succeeded',
            updateFail:'Failed',
            // xTime:['周一','周二','周三','周四','周五','周六','周日']
            xTime:['DBY','Yesterday','Today']
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/common/lang/en/overview.js